import React from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../../../template/MainTheme/components/Breadcrumbs';
import { Tabs, Tab } from 'react-bootstrap';
import QuoteTab from '../tabs/QuoteTab';
import QuoteRouteSegmentsContainer from '../QuoteRouteSegmentsContainer';
import QuoteDetailsContainer from '../QuoteDetailsContainer';
import { QuoteDataForm, QuoteOfferTypeDataForm, QuoteReferenceDataForm } from '../../../../app/models/Quote';
import { Society } from '../../../../app/models/Society';
import { Client } from '../../../../app/models/Client';
import { PaymentCondition } from '../../../../app/models/PaymentCondition';
import { Currency } from '../../../../app/models/Currency';
import { QuoteRouteSegment } from '../../../../app/models/QuoteRouteSegment';
import { Sector } from '../../../../app/models/Sector';
import DefaultCard from '../../../../components/default/DefaultCard';
import QuoteInvoicingForm from '../forms/QuoteInvoicingForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import LazyLoading from '../../../../components/LazyLoading';
import { QuoteInvoicingDataForm } from '../../../../app/models/QuoteInvoicing';
import { ExchangeRateDate } from '../../../../app/models/ExchangeRateDate';
import { ExchangeRateDateSource } from '../../../../app/models/ExchangeRateDateSource';
import { ClientContact } from '../../../../app/models/ClientContact';
import { Unit } from '../../../../app/models/Unit';
import { SectorBusinessRulesEnum } from '../../../../app/shared/enums';

interface Props {
    id: number;
    quoteForm: QuoteDataForm;
    setQuoteForm: (quote: QuoteDataForm) => void;
    societies: Society[];
    clients: Client[];
    paymentConditions: PaymentCondition[];
    references: QuoteReferenceDataForm[];
    paymentMethods: PaymentCondition[];
    currencies: Currency[];
    offerTypes: QuoteOfferTypeDataForm[];
    sectors: Sector[];
    // Ajustado: se espera un único enum (o string) en lugar de array
    sectorBusinessRulesEnum?: SectorBusinessRulesEnum | string;
    clientContacts: ClientContact[];
    errorFields: any;
    condition: boolean;
    disableUpdate: boolean;
    loadingClient: boolean;
    isEdit: boolean;
    fetchingQuote: boolean;
    quoteCheckDocument: boolean;
    quoteRouteSegments: QuoteRouteSegment[];
    setQuoteRouteSegments: (segments: QuoteRouteSegment[]) => void;
    reloadQuoteRouteSegmentTable: () => void;
    update: () => void;
    sectorId: number;
    reloadQuote: (id: number) => void;
    currencyId: number;
    quoteInvoicingForm: QuoteInvoicingDataForm;
    setQuoteInvoicingForm: (f: QuoteInvoicingDataForm) => void;
    fetchingQuoteInvoicingByQuote: boolean;
    fetchingUpdateQuoteInvoicing: boolean;
    updateInvoicing: () => void;
    exchangeRateDate: ExchangeRateDate[];
    exchangeRateDateSource: ExchangeRateDateSource[];
    units: Unit[];
}

const QuoteEditContainer = ({
    id,
    quoteForm,
    setQuoteForm,
    societies,
    clients,
    paymentConditions,
    references,
    paymentMethods,
    currencies,
    offerTypes,
    sectors,
    errorFields,
    condition,
    disableUpdate,
    loadingClient,
    isEdit,
    fetchingQuote,
    quoteCheckDocument,
    quoteRouteSegments,
    setQuoteRouteSegments,
    reloadQuoteRouteSegmentTable,
    update,
    sectorId,
    reloadQuote,
    currencyId,
    quoteInvoicingForm,
    setQuoteInvoicingForm,
    fetchingQuoteInvoicingByQuote,
    fetchingUpdateQuoteInvoicing,
    updateInvoicing,
    exchangeRateDate,
    exchangeRateDateSource,
    clientContacts,
    units,
    sectorBusinessRulesEnum


}: Props) => {
    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Cotizaciones',
            url: '/quotes',
            isActive: false
        },
        {
            name: 'Editar cotización #' + id,
            url: '/quotes/' + id + '/edit',
            isActive: true
        }
    ];

    const handleUpdate = () => {
        reloadQuote(id); // o setRefresh((prev) => !prev);
    };

    const isDefecto = sectorBusinessRulesEnum === SectorBusinessRulesEnum.DEFECTO;

    return (
        <>
            <Breadcrumbs pageSection={`Editar Oferta #${id}`} breadcrumbs={breadcrumbs} />
            <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <QuoteTab
                        fetchingQuote={fetchingQuote}
                        update={update}
                        quoteForm={quoteForm}
                        setQuoteForm={setQuoteForm}
                        societies={societies}
                        clients={clients}
                        paymentConditions={paymentConditions}
                        references={references}
                        paymentMethods={paymentMethods}
                        offerTypes={offerTypes}
                        currencies={currencies}
                        sectors={sectors}
                        clientContacts = {clientContacts}
                        errorFields={errorFields}
                        condition={condition}
                        disableUpdate={disableUpdate}
                        loadingClient={loadingClient}
                        isEdit={isEdit}
                        sectorBusinessRulesEnum={sectorBusinessRulesEnum}
                    />
                </Tab>
                <Tab eventKey="invoicing" title="Facturación">
                    <DefaultCard>
                        {!fetchingQuoteInvoicingByQuote ? (
                            <>
                                <QuoteInvoicingForm
                                    quoteInvoicingDataForm={quoteInvoicingForm}
                                    setQuoteInvoicingDataForm={setQuoteInvoicingForm}
                                    currencies={currencies}
                                    references={references}
                                    paymentMethods={paymentMethods}
                                    exchangeRateDate={exchangeRateDate}
                                    exchangeRateSource={exchangeRateDateSource}
                                    units={units}
                                    errorFields={errorFields}
                                    
                                />
                                <div className="row justify-content-end">
                                    <div className="col-auto">
                                        <ButtonSaveForm
                                            callbackSave={updateInvoicing}
                                            locked={fetchingUpdateQuoteInvoicing}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </Tab>

                <Tab eventKey="interlocutors" title="Interlocutores" disabled>
                    Interlocutores
                </Tab>
                {!isDefecto && (
                    <Tab eventKey="options" title="Opciones">
                        <QuoteRouteSegmentsContainer
                            quoteId={id}
                            quoteCheckDocument={quoteCheckDocument}
                            quoteRouteSegments={quoteRouteSegments}
                            setQuoteRouteSegments={setQuoteRouteSegments}
                            refreshQuoteDetail={handleUpdate}
                        />
                    </Tab>
                )}
                <Tab eventKey="management" title="Gestión" disabled>
                    Gestión
                </Tab>
            </Tabs>

            <QuoteDetailsContainer
                quoteId={id}
                sectorId={sectorId}
                currencyId={currencyId}
                quoteForm={quoteForm}
                setQuoteForm={setQuoteForm}
                reloadQuoteRouteSegmentTable={reloadQuoteRouteSegmentTable}
                reloadQuote={reloadQuote}
            />
        </>
    );
};

export default QuoteEditContainer;
